(() => {
  const hostSelector = [
    '.pcn-s04-form shopify-forms-embed',
    '.rd-s04-form shopify-forms-embed',
    '.pcn-s04-form form-embed#app-embed',
    '.rd-s04-form form-embed#app-embed',
  ].join(',');
  const rootSelector = [
    '.pcn-s04-form [data-form-root="true"]',
    '.rd-s04-form [data-form-root="true"]',
  ].join(',');

  const styleId = 'aroundrs-shopify-forms-contrast';
  const styles = `
    :host {
      display: block !important;
      color: #12383d !important;
      font-family: inherit !important;
      background: transparent !important;
      box-shadow: none !important;
    }

    * {
      box-sizing: border-box !important;
    }

    form {
      display: grid !important;
      gap: 1.2rem !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
    }

    fieldset {
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
    }

    label {
      display: block !important;
      margin-bottom: 0.45rem !important;
      color: #12383d !important;
      font-weight: 650 !important;
      font-size: 0.92rem !important;
      line-height: 1.45 !important;
    }

    label:has(input[type='checkbox']) {
      display: flex !important;
      align-items: center !important;
      gap: 0.65rem !important;
      margin: 0 !important;
    }

    label:has(input[type='checkbox']) [class*='_checkboxWrapper_'] {
      flex: 0 0 auto !important;
    }

    :host(.aroundrs-floating-form)
      :is(input:not([type='checkbox']):not([type='radio']), textarea):is(:focus, .aroundrs-has-value) {
      padding-top: 1.35rem !important;
      padding-bottom: 0.55rem !important;
    }

    :host(.aroundrs-floating-form)
      textarea:is(:focus, .aroundrs-has-value) {
      padding-top: 1.75rem !important;
      padding-bottom: 0.15rem !important;
    }

    :host(.aroundrs-floating-form)
      :is(input:not([type='checkbox']):not([type='radio']), textarea):is(:focus, .aroundrs-has-value)
      + label {
      top: 0.35rem !important;
      margin: 0 !important;
      font-size: 0.7rem !important;
      font-weight: 300 !important;
      line-height: 1 !important;
      opacity: 0.6 !important;
      transform: none !important;
    }

    :host(.aroundrs-floating-form)
      :is(input:not([type='checkbox']):not([type='radio']), textarea) {
      font-weight: 700 !important;
    }

    :host(.aroundrs-floating-form) label:not(:has(input[type='checkbox'])) {
      font-weight: 300 !important;
    }

    :host(.aroundrs-floating-form) [class*='_selectContainer_'] {
      position: relative !important;
    }

    :host(.aroundrs-floating-form)
      [class*='_selectContainer_']
      > p[id$='-selector-label'] {
      position: absolute !important;
      top: 1.825rem !important;
      left: 1rem !important;
      z-index: 2 !important;
      margin: 0 !important;
      padding: 0 !important;
      font-size: 1rem !important;
      font-weight: 300 !important;
      line-height: 1 !important;
      opacity: 1 !important;
      pointer-events: none !important;
      transform: translateY(-50%) !important;
      transition:
        top 180ms ease,
        font-size 180ms ease,
        opacity 180ms ease,
        transform 180ms ease !important;
    }

    :host(.aroundrs-floating-form)
      [class*='_selectContainer_']
      button[aria-expanded] {
      font-weight: 700 !important;
    }

    :host(.aroundrs-floating-form)
      [class*='_selectContainer_']:has(
        button[aria-expanded]:is(:focus, [aria-expanded='true']),
        [id$='-selector-value']:not(:empty)
      )
      button[aria-expanded] {
      padding-top: 1.35rem !important;
      padding-bottom: 0.55rem !important;
    }

    :host(.aroundrs-floating-form)
      [class*='_selectContainer_']:has(
        button[aria-expanded]:is(:focus, [aria-expanded='true']),
        [id$='-selector-value']:not(:empty)
      )
      > p[id$='-selector-label'] {
      top: 0.35rem !important;
      font-size: 0.7rem !important;
      opacity: 0.6 !important;
      transform: none !important;
    }

    input:not([type='checkbox']):not([type='radio']),
    select,
    textarea,
    button[aria-expanded] {
      width: 100% !important;
      background: #ffffff !important;
      min-height: 3.65rem !important;
      padding: 0.95rem 1rem !important;
      border-width: 1px !important;
      border-style: solid !important;
      border-color: #d9d3c6 !important;
      border-radius: 14px !important;
      background-clip: padding-box !important;
      color: #102f33 !important;
      box-shadow: none !important;
      font-size: 1rem !important;
      line-height: 1.45 !important;
    }

    input:not([type='checkbox']):not([type='radio'])::placeholder,
    textarea::placeholder {
      color: #607276 !important;
      opacity: 1 !important;
    }

    input:not([type='checkbox']):not([type='radio']):hover,
    select:hover,
    textarea:hover,
    button[aria-expanded]:hover {
      border-color: #94abad !important;
    }

    input:not([type='checkbox']):not([type='radio']):focus,
    select:focus,
    textarea:focus,
    button[aria-expanded]:focus,
    button[aria-expanded]:focus-visible {
      border-color: #a84e35 !important;
      outline: 3px solid rgba(168, 78, 53, 0.22) !important;
      outline-offset: 1px !important;
    }

    textarea {
      min-height: 9rem !important;
      resize: vertical !important;
    }

    [class*='_formFieldContainer_']:has(textarea) {
      border: 1px solid #d9d3c6 !important;
      border-radius: 14px !important;
      background: #ffffff !important;
      overflow: hidden !important;
    }

    :host(.aroundrs-floating-form)
      [class*='_formFieldContainer_']:has(
        textarea:is(:focus, .aroundrs-has-value)
      )::before {
      height: 1rem !important;
    }

    [class*='_formFieldContainer_']:has(textarea) textarea {
      border: 0 !important;
      border-radius: 0 !important;
      background: transparent !important;
    }

    [class*='_formFieldContainer_']:has(textarea):hover {
      border-color: #94abad !important;
    }

    [class*='_formFieldContainer_']:has(textarea:focus) {
      border-color: #a84e35 !important;
      outline: 3px solid rgba(168, 78, 53, 0.22) !important;
      outline-offset: 1px !important;
    }

    [class*='_formFieldContainer_']:has(textarea:focus) textarea {
      outline: 0 !important;
    }

    [class*='_selectContainer_'] {
      overflow: visible !important;
    }

    [class*='_selectContainer_']:has(button[aria-expanded='true']) {
      z-index: 20 !important;
    }

    [class*='_dropdownContainer_'] {
      top: calc(100% + 0.4rem) !important;
      right: auto !important;
      bottom: auto !important;
      left: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
      border: 1px solid #d9d3c6 !important;
      border-radius: 14px !important;
      background: #ffffff !important;
      box-shadow: 0 14px 30px rgba(18, 56, 61, 0.14) !important;
      overflow: hidden !important;
      z-index: 30 !important;
    }

    [class*='_optionList_'] {
      width: 100% !important;
      max-width: 100% !important;
    }

    a {
      color: #a84e35 !important;
    }

    button[type='submit'] {
      width: 100% !important;
      min-height: 3.9rem !important;
      padding: 1rem 1.4rem !important;
      margin-top: 0.5rem !important;
      background: #00525e !important;
      border: 1px solid #00525e !important;
      border-radius: 14px !important;
      color: #ffffff !important;
      font-family: inherit !important;
      font-size: 1.04rem !important;
      font-weight: 700 !important;
      letter-spacing: 0 !important;
      box-shadow: none !important;
    }

    button[type='submit']:hover {
      background: #003f48 !important;
      border-color: #003f48 !important;
    }

    button[type='submit']:focus-visible {
      outline: 3px solid rgba(168, 78, 53, 0.35) !important;
      outline-offset: 3px !important;
    }

    @media (max-width: 749px) {
      form {
        gap: 1rem !important;
      }

      input:not([type='checkbox']):not([type='radio']),
      select,
      textarea,
      button[aria-expanded],
      button[type='submit'] {
        min-height: 3.45rem !important;
      }

      :host(.aroundrs-floating-form)
        [class*='_selectContainer_']
        > p[id$='-selector-label'] {
        top: 1.725rem !important;
      }

      :host(.aroundrs-floating-form)
        [class*='_selectContainer_']:has(
          button[aria-expanded]:is(:focus, [aria-expanded='true']),
          [id$='-selector-value']:not(:empty)
        )
        > p[id$='-selector-label'] {
        top: 0.35rem !important;
      }
    }
  `;

  const attempts = new WeakMap();
  const wiredFields = new WeakSet();

  const applyContrast = (embed) => {
    embed.classList.toggle(
      'aroundrs-floating-form',
      Boolean(embed.closest('.rd-s04-form, .pcn-s04-form'))
    );

    if (embed.shadowRoot) {
      if (!embed.shadowRoot.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = styles;
        embed.shadowRoot.append(style);
      }

      embed.shadowRoot
        .querySelectorAll(
          "input:not([type='checkbox']):not([type='radio']), textarea"
        )
        .forEach((field) => {
          const syncValueState = () => {
            field.classList.toggle(
              'aroundrs-has-value',
              Boolean(field.value.trim())
            );
          };

          syncValueState();
          if (wiredFields.has(field)) return;

          wiredFields.add(field);
          field.addEventListener('input', syncValueState);
          field.addEventListener('change', syncValueState);
        });

      return;
    }

    const attempt = (attempts.get(embed) || 0) + 1;
    attempts.set(embed, attempt);
    if (attempt < 80) window.setTimeout(() => applyContrast(embed), 200);
  };

  const scan = () => {
    document.querySelectorAll(rootSelector).forEach((root) => {
      const block = root.closest('.shopify-block');
      if (!block) return;

      block.classList.toggle(
        'aroundrs-shopify-form--pending',
        !root.querySelector('shopify-forms-embed, form-embed#app-embed')
      );
    });

    document.querySelectorAll(hostSelector).forEach(applyContrast);
  };

  scan();
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
